
export default function About() {
  return (
    <section id="about" className="py-24 bg-gradient-to-b from-black to-zinc-900">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="absolute inset-0 bg-amber-400/20 blur-3xl rounded-full"></div>
            <img 
              src="https://static.readdy.ai/image/2cff082c3240b86a1a45c3f20eab75c2/9e48fa8535899f8daec2ab0b4437bd47.png" 
              alt="Jacob - Mercedes Sales Specialist"
              className="relative rounded-lg shadow-2xl w-full h-full object-cover object-top"
            />
          </div>
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Meet <span className="text-amber-400">Jacob</span>
            </h2>
            <p className="text-gray-300 text-lg mb-6 leading-relaxed">
              I'm Jacob. Husband to Alison, dog dad to Bella, and getting ready to welcome our son, Jack!
            </p>
            <p className="text-gray-300 text-lg mb-6 leading-relaxed">
              Family shapes everything I do, including how I work with my clients. Buying a car should feel exciting, not stressful. Clear communication, honest guidance, and zero pressure.
            </p>
            <p className="text-gray-300 text-lg mb-6 leading-relaxed">
              Most of my business is done with clients out of state, which means everything I do has to be transparent, organized, and handled right the first time. From the first conversation to delivery, I focus on making the process smooth and straightforward.
            </p>
            <p className="text-gray-300 text-lg mb-6 leading-relaxed">
              Whether it's your first Mercedes or something truly special, my goal is simple. Make the experience easy, efficient, and enjoyable.
            </p>
            <p className="text-gray-300 text-lg mb-8 leading-relaxed">
              If you value straight answers and a relationship you can trust, you're in the right place.
            </p>
            <p className="text-gray-300 text-lg mb-8 leading-relaxed font-semibold">
              Let's make it easy.
            </p>
            <div className="grid grid-cols-3 gap-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-amber-400 mb-2">10+</div>
                <div className="text-gray-400 text-sm">Years Experience</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-amber-400 mb-2">500+</div>
                <div className="text-gray-400 text-sm">Happy Clients</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-amber-400 mb-2">98%</div>
                <div className="text-gray-400 text-sm">Satisfaction Rate</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
